import { c as _c } from "react/compiler-runtime";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { post } from "@/data/api";
const queryKeyHasFerdigstiltForhandsVarsel = ["hasFerdigstiltForhandsVarsel"];
export const useFerdigstillForhandsVarsel = () => {
  const $ = _c(5);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: queryKeyHasFerdigstiltForhandsVarsel,
      queryFn: _temp,
      initialData: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: hasFerdigstiltForhandsvarsel
  } = useQuery(t0);
  let t1;
  let t2;
  if ($[1] !== hasFerdigstiltForhandsvarsel || $[2] !== queryClient) {
    t1 = () => {
      const ferdigstillForhandsvarselIfNotAlreadyDone = async () => {
        if (!hasFerdigstiltForhandsvarsel) {
          await post("/syk/aktivitetskrav/api/aktivitetsplikt/les");
          queryClient.setQueryData(queryKeyHasFerdigstiltForhandsVarsel, true);
        }
      };
      ferdigstillForhandsvarselIfNotAlreadyDone();
    };
    t2 = [hasFerdigstiltForhandsvarsel, queryClient];
    $[1] = hasFerdigstiltForhandsvarsel;
    $[2] = queryClient;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
};
function _temp() {
  return false;
}